import assetPath from '/app/xinglets/business-solutions/page/src/assets/recruiting.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')